export const TIPOS_ASESOR = [
    {
        "idTipoAsesor": 1,
        "Descripcion": "Asesor Financiero Balanz",
        "DescripcionCorta": "Asesor",
    },
    {
        "idTipoAsesor": 2,
        "Descripcion": "Asistente Financiero Balanz",
        "DescripcionCorta": "Asistente",
    },
    {
        "idTipoAsesor": 3,
        "Descripcion": "Productor",
        "DescripcionCorta": "Productor",
    },
    {
        "idTipoAsesor": 4,
        "Descripcion": "Referenciador",
        "DescripcionCorta": "Referenciador",
    },
    {
        "idTipoAsesor": 5,
        "Descripcion": "Backoffice",
        "DescripcionCorta": "Backoffice",
    },
    {
        "idTipoAsesor": 6,
        "Descripcion": "Referidor",
        "DescripcionCorta": "Referidor",
    },
    {
        "idTipoAsesor": 7,
        "Descripcion": "Productor AAGI",
        "DescripcionCorta": "Prod AGGI",
    },
    {
        "idTipoAsesor": 8,
        "Descripcion": "Usuario Externo",
        "DescripcionCorta": "Usuario Ext",
    },
    {
        "idTipoAsesor": 10,
        "Descripcion": "Cliente",
        "DescripcionCorta": "Cliente",
    }
]